import { supabase } from "@/integrations/supabase/client";

/** Elan şikayətlərinin standart səbəbləri. */
export const REPORT_REASONS = [
  { value: "saxta", label: "Saxta və ya aldadıcı elan" },
  { value: "qiymet", label: "Qiymət düzgün deyil" },
  { value: "satilib", label: "Məhsul artıq satılıb" },
  { value: "qadagan", label: "Qadağan olunmuş məhsul/xidmət" },
  { value: "spam", label: "Spam və ya təkrar elan" },
  { value: "elaqe", label: "Satıcı əlaqə saxlamır / nömrə yanlışdır" },
  { value: "sekil", label: "Şəkillər elana uyğun deyil" },
  { value: "deyanet", label: "Təhqir, dələduzluq və ya uyğunsuz məzmun" },
  { value: "diger", label: "Digər səbəb" },
] as const;

export type ReportReasonValue = (typeof REPORT_REASONS)[number]["value"];

export const reportReasonLabel = (value: string) =>
  REPORT_REASONS.find((r) => r.value === value)?.label ?? value;

/** Elan barədə şikayət göndərir (yalnız daxil olmuş istifadəçi). */
export async function submitReport(input: {
  listingId?: string | null;
  reportedUserId?: string | null;
  reason: string;
  details?: string;
}) {
  const { data: auth } = await supabase.auth.getUser();
  const uid = auth.user?.id;
  if (!uid) throw new Error("Şikayət göndərmək üçün hesabınıza daxil olun");

  const { error } = await supabase.from("reports").insert({
    listing_id: input.listingId ?? null,
    reported_user_id: input.reportedUserId ?? null,
    reporter_id: uid,
    reason: reportReasonLabel(input.reason),
    details: input.details?.trim() || null,
    status: "open",
  });
  if (error) throw error;
}
